module.exports = ol.source.ImageWMS;